/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSquareOnlineSiteMappingRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {GetSquareOnlineSiteMappingResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const getSquareOnlineSiteMapping = (request: GetSquareOnlineSiteMappingRequest, options?: CashRequestOptions) => post<GetSquareOnlineSiteMappingRequest, GetSquareOnlineSiteMappingResponse>("/2.0/cash/get-square-online-site-mapping", request, {...options, rejectOnError: true })